import * as actionTypes from "../constants/actionTypes";

/**
 * Structure of favoritesTab store:
 * - folderId {object}  - selected folder id
 */
export const favoritesTabReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.FAVORITES_TAB_INIT:
            let initialState = {};
            initialState = {
                folderId: null
            };

            return {...state, ...initialState};
        case actionTypes.SELECT_TAB_FAVORITE_FOLDER:
            return {
                ...state,
                name: action.payload.name,
                parentId: action.payload.parentId,
                folderId: action.payload.folderId
            };
        case actionTypes.DELETE_FAVORITES_FOLDER:
            return {
                ...state,
                folderId: null
            };
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return {
                folderId: null
            };
        default:
            return state;
    }
};
